class Core7VideoModal extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);

    this.modals = Array.from(this.querySelectorAll('[data-video-modal]'));
    this.modals.forEach((modal) => {
      // Close when the backdrop (the dialog element itself) is clicked.
      modal.addEventListener('click', (event) => {
        if (event.target === modal) this.closeModal(modal);
      });
      // Fires on Escape, the close button, and backdrop click — stop playback.
      modal.addEventListener('close', () => this.stopMedia(modal));
    });
  }

  onClick(event) {
    const opener = event.target.closest('[data-video-open]');
    if (opener && this.contains(opener)) {
      event.preventDefault();
      this.openModal(opener.getAttribute('data-video-open'));
      return;
    }

    const closer = event.target.closest('[data-video-close]');
    if (closer && this.contains(closer)) {
      const modal = closer.closest('[data-video-modal]');
      if (modal) this.closeModal(modal);
    }
  }

  openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    this.startMedia(modal);

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  closeModal(modal) {
    if (typeof modal.close === 'function') {
      modal.close(); // triggers the 'close' event, which stops media
    } else {
      modal.removeAttribute('open');
      this.stopMedia(modal);
    }
  }

  // Load the embed only when opened (iframes use data-src) and start playback.
  startMedia(modal) {
    const frame = modal.querySelector('[data-src]');
    if (frame && !frame.getAttribute('src')) {
      frame.setAttribute('src', frame.getAttribute('data-src'));
    }

    const video = modal.querySelector('video');
    if (video) {
      try {
        video.currentTime = 0;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => {});
        }
      } catch (error) {
        /* autoplay may be blocked; controls remain available */
      }
    }
  }

  // Stop playback so audio doesn't continue after closing.
  stopMedia(modal) {
    const frame = modal.querySelector('[data-src]');
    if (frame) {
      frame.setAttribute('src', '');
    }

    const video = modal.querySelector('video');
    if (video) {
      video.pause();
    }
  }
}

if (!customElements.get('core7-video-modal')) {
  customElements.define('core7-video-modal', Core7VideoModal);
}
